<template>
    <div>
      标定交付
    </div>
  </template>

<script>
export default {

};
</script>

  <style>

  </style>
